import AdiSiteErrorNormalizer from './AdiSite';
import { ApiType, ErrorType, IErrorNormalizer, VmafError } from './types';
import VideoMakerAssetsErrorNormalizer from './VideoMakerAssets';
import VideoMakerVideoErrorNormalizer from './VideoMakerVideo';
import WixWizErrorNormalizer from './WixWiz';

export default class ErrorNormalizer {
  private readonly _normalizer: IErrorNormalizer;

  constructor(apiType: ApiType) {
    if (apiType === ApiType.WIX_WIZ) {
      this._normalizer = new WixWizErrorNormalizer();
    } else if (apiType === ApiType.VIDEO_MAKER_ASSETS) {
      this._normalizer = new VideoMakerAssetsErrorNormalizer();
    } else if (apiType === ApiType.VIDEO_MAKER_VIDEO) {
      this._normalizer = new VideoMakerVideoErrorNormalizer();
    } else if (apiType === ApiType.ADI) {
      this._normalizer = new AdiSiteErrorNormalizer();
    }
  }

  normalizeError(error: Error): VmafError {
    return this._normalizer
      ? this._normalizer.normalizeToVmafError(error)
      : new VmafError(error.message, ErrorType.UNHANDLED, error);
  }
}

export * from './types';
